var _style, _rect, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1440 240",
    style: {
      enableBackground: "new 0 0 1440 240"
    },
    xmlSpace: "preserve",
    width: 1440,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .gradient{fill:url(#artdeco-banner-graph-gradient1);}\n    .foreground{opacity:0.15;}\n    .midground{opacity:0.3;}\n    .background{opacity:0.5;}\n    .foreground circle, .midground circle, .background circle {fill:#FFFFFF;}\n    .foreground polyline, .midground polyline, .background polyline {fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n    .foreground polygon, .midground polygon, .background polygon {fill:none;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:10;}\n    .foreground line, .midground line, .background line{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n  ")), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "artdeco-banner-graph-gradient1",
    gradientUnits: "userSpaceOnUse",
    x1: 18.2309,
    y1: 308.1425,
    x2: 1421.7692,
    y2: -67.9344
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#008CC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009EA5"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.1,
    className: "gradient",
    width: 1440,
    height: 240
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "foreground"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 32.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.1,
    cy: 41,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.5,
    cy: 9,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.5,
    cy: 37.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 105.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.5,
    cy: 149.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.8,
    cy: 136.2,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.5,
    cy: 178.2,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 453.5,
    cy: 171.6,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 71.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 44.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 453.5,
    cy: 43,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 484,
    cy: 94.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 527.4,
    cy: 148.7,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 571,
    cy: 194.7,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 204.7,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 681.2,
    cy: 78.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 739.5,
    cy: 82,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 773,
    cy: 183.1,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 816.9,
    cy: 209.7,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 803.3,
    cy: 33.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 55,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 585.5,
    cy: 11,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 947.9,
    cy: 40.3,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994.5,
    cy: 9.9,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1043.5,
    cy: 37,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 983.3,
    cy: 108.7,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1008.7,
    cy: 150.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1130.5,
    cy: 137,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1095,
    cy: 43.8,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 927.3,
    cy: 202.7,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 214.7,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1148,
    cy: 179,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 169,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1159.5,
    cy: 69.8,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 40.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1245.5,
    cy: 96,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1289.5,
    cy: 147.4,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1332.4,
    cy: 196.3,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1384.2,
    cy: 204.4,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.5,
    cy: 221.2,
    r: 3.5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12.5,-3.5 42,32.5 111,-3.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42,32.5 184.1,41 195.5,-13"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "229.5,9 281.5,37.5 335,44.5 281.5,-16 281.5,37.5 249.5,149.5 222.5,105.5 229.5,9 184.1,0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.6,
    y1: 38.8,
    x2: 222.5,
    y2: 105.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 369.6,
    y1: 136.2,
    x2: 249.5,
    y2: 149.5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "333.7,43 394,71.5 368,136.5 281.5,37.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394,71.5 453.5,43 484,94.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459,
    y1: 0,
    x2: 453.5,
    y2: 43
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "366.2,0 394,71.5 440.8,-1.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "394,71.5 453.5,171.6 527.4,148.7 493.5,221.2 385.5,178.2 335,44.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.5,
    y1: 172.8,
    x2: 385,
    y2: 176.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.5,
    y1: 171.6,
    x2: 368.8,
    y2: 136.2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "571,240 624,204.7 646.5,242.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "624,204.7 731.2,228.5 773,182 816.9,208.5 816.9,240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.9,213.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "681.2,77.2 739.5,82 772,183.1 681.2,78.5 624,204.7 571,194.7 493.5,221.2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780.5,
    y1: 111.2,
    x2: 739.5,
    y2: 83.2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "630.5,-2.5 634,55 585.5,11 592.5,-7.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 634,
    y1: 55,
    x2: 760,
    y2: -5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "769.5,-7.5 803.3,33.5 885.5,-5"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "803.3,33.5 947.9,40.3 951.4,0 994.5,9.9 1043.5,37 1043.5,-14.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1032.5,-14.5 1095,43.8 1043.5,37 1130.5,137 1008.7,150.5 983.3,108.7 994.5,9.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "983.3,108.7 1043.5,37 1008.7,150.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1130.5,-5 1159.5,69.8 1130.5,137 1148,179 1218.5,169 1159.5,69.8 1249,96"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1095,43.8 1159.5,69.8 1215,40.5 1245.5,99.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1215,
    y1: 40.5,
    x2: 1222.5,
    y2: -5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1215,169 1289.5,147.4 1252.2,222 1148,182.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1440,76.5 1384.2,200.9 1332.4,196.3 1308.5,240"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1323.5,240.4 1384.2,207.9 1417.5,247.5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "midground"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61.6,
    cy: 173.2,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.6,
    cy: 94.5,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.2,
    cy: 231.9,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284,
    cy: 161.6,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.5,
    cy: 201.7,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 508.3,
    cy: 168.2,
    r: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "94.9,240 61.6,173.2 180.6,94.5 159.2,232 180.9,240.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "313.6,240.4 284,161.6 341.5,189.7 323.4,240"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "341.5,189.7 379.5,204.1 366.5,240"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "379.5,204.1 508.3,168.2 423.5,240.4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 508.3,
    y1: 168.2,
    x2: 548.4,
    y2: 240.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "background"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 922.3,
    cy: 40.3,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1033,
    cy: 108.7,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1095,
    cy: 60,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1186.5,
    cy: 1.4,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1149.5,
    cy: 96,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1172,
    cy: 154.5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1240.5,
    cy: 145.5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1308.2,
    cy: 137,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1303.2,
    cy: 59,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1363.7,
    cy: 43.5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1414,
    cy: 0.4,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1425.5,
    cy: 114,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1384.2,
    cy: 160.5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1289.5,
    cy: 226,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1380.2,
    cy: 217,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1425.5,
    cy: 199.3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1420.5,
    cy: 74,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685.5,
    cy: 211.7,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490.5,
    cy: 237,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397,
    cy: 186.1,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.5,
    cy: 189.7,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1021.7,
    cy: 179,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862,
    cy: 204.7,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 816.9,
    cy: 153.7,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 779.5,
    cy: 113.2,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 717,
    cy: 181.1,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.5,
    cy: 225,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 240.4,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262.5,
    cy: 89.5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 32.5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 221.5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.5,
    cy: 199.7,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 209.7,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 100.5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 194.7,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 734.5,
    cy: 214.7,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 64,
    x2: 1308.2,
    y2: 137
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1363.7,
    y1: 43.5,
    x2: 1308.2,
    y2: 137
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1303.2,
    y1: 59,
    x2: 1308.2,
    y2: 137
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1308.2,
    y1: 137,
    x2: 1289.5,
    y2: 226
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1308.2,
    y1: 137,
    x2: 1191.7,
    y2: 210.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1308.2,
    y1: 137,
    x2: 1173,
    y2: 155.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1303.2,
    y1: 59,
    x2: 1191.7,
    y2: 210.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1384.2,
    y1: 160.5,
    x2: 1269,
    y2: 240.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 160.5,
    x2: 1384.2,
    y2: 160.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380.2,
    y1: 217,
    x2: 1384.2,
    y2: 160.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1425.5,
    y1: 199.3,
    x2: 1380.2,
    y2: 217
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1425.5,
    y1: 200.7,
    x2: 1405.8,
    y2: 239.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1425.5,
    y1: 199.3,
    x2: 1439.8,
    y2: 206
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1363.7,
    y1: 43.5,
    x2: 1384.2,
    y2: 160.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1363.7,
    y1: 43.5,
    x2: 1425.5,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1334.4,
    y1: 0,
    x2: 1363.7,
    y2: 43.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1316,
    y1: -1.4,
    x2: 1303.2,
    y2: 59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1363.7,
    y1: 43.7,
    x2: 1149.5,
    y2: 96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1414,
    y1: 0,
    x2: 1425.5,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 81.8,
    x2: 1421.5,
    y2: 74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440.4,
    y1: 127.3,
    x2: 1423.5,
    y2: 111.7
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1414,0.4 1363.7,43.5 1186.5,1.4 1095,60 1149.5,94 1191.7,210.3 1368.9,240.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1173,155.5 1021.7,179 1149.5,96 1187,1.7 1303.7,59"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1021.7,
    y1: 179,
    x2: 1122,
    y2: 240.4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1156.4,240.4 1191.7,210.3 1189.1,240.4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1022.7,
    y1: 177.3,
    x2: 956.9,
    y2: 240.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1031.2,
    y1: 109.7,
    x2: 1149.5,
    y2: 96
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1034,108.7 922.3,40.3 1095,60"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "772,240.6 816.9,153.7 779.5,113.7 685.5,211.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "826.7,240 862,204.7 816.9,153.7 922.3,40.3 862,204.7 1033,108.7 1020.9,179 862,204.7 1071.8,240.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "803.3,240.4 734.5,214.7 705.3,240.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 717.7,
    y1: 240,
    x2: 666,
    y2: 194.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 666.4,
    y1: 194.7,
    x2: 678.7,
    y2: 240.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 666.4,
    y1: 194.7,
    x2: 816.9,
    y2: 153.7
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "779.5,113.7 490.5,237 397,186.1 341.5,189.7 397.2,240.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "424.3,240.1 414.5,225 289,240.4 262.5,89.5 716.4,181.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "206,32.5 29.5,100.5 200,221.5 206,32.5 262.5,89.5 200,221.5 289,240.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "177,240.4 200,221.5 101.5,199.7 29.5,100.5 14,209.7 36.4,240.4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 209.7,
    x2: 3.3,
    y2: 240.1
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "94.9,240 101.5,199.7 19,209.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "0,95.5 29.5,100.5 0,56"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.831a7681b085f971a3f216eac0bb4783.svg";
export { ForwardRef as ReactComponent };